import { GQL_ID, Product } from '@@types'
import { gql, useQuery } from '@apollo/client'

import {
  SHORTCUT_PRODUCT_ATTRIBUTES,
  SHORTCUT_PRODUCT_FIELDS,
  SHORTCUT_PRODUCT_SHOP_INFO,
} from '@shared/graphql/shortcuts'

interface ProductQuery {
  product: Product
}

interface ProductVariables {
  shopId: GQL_ID
  id?: GQL_ID
  slug?: string
  style?: string
  imageStyles?: string
  galleryStyles?: string
  previewStyle2?: string
}

export const GQL_QUERY_PRODUCT = gql`
  query product (
    $shopId: ID!
    $id: ID
    $slug: String
    $style: String
    $previewStyle2: String
    $imageStyles: String
    $galleryStyles: String
  ) {
    product(shop_id: $shopId, id: $id, slug: $slug) {
      ${SHORTCUT_PRODUCT_FIELDS}
      ${SHORTCUT_PRODUCT_ATTRIBUTES}
      ${SHORTCUT_PRODUCT_SHOP_INFO}
      
      short_description
      nutval
      ingredients
      productProperties {
        fats
        proteins
        calories
        shelfLife
        carbohydrate
        manufacturerName
        country
      }
      fullPreview: preview(style: $previewStyle2) {
        url
      }
      images(style: $imageStyles) {
        url
      }
      galleryImages: images(style: $galleryStyles) {
        url
      }
      brand {
        id
        name
      }
      categories {
        id
        name
        slug
        parent_id
        icon {
          url
        }
        parent {
          id
          name
          slug
        }
      }
      isFavorite
      canBeReviewed
    }
  }
`

export const useFetchProduct = (variables: ProductVariables) => {
  const { data, loading, error, refetch } = useQuery<ProductQuery, ProductVariables>(
    GQL_QUERY_PRODUCT,
    {
      variables,
      skip: !variables.id && !variables.slug,
      fetchPolicy: 'cache-and-network',
    },
  )

  return {
    data,
    product: data?.product,
    loading,
    error,
    refetch,
  }
}
